// Wat er in de stippengrafiek van de materialen-detailpagina komt, en hoe ver
// de as loopt. Rekent geen niveaus uit: die komen van de server, via
// buildMaterialContextRows.
//
// AI-CONTEXT: See docs/features/intelligence-thema-eerst.md

const STAP = 50

/**
 * @typedef {import('./buildMaterialContextRows').MaterialContextSection} MaterialContextSection
 */

/**
 * @param {MaterialContextSection[]|null} sections - Uit buildMaterialContextRows
 * @param {number|null} reference - De benchmark van de basis; de lijn in de grafiek
 * @returns {{sections: MaterialContextSection[], max: number}}
 */
const buildMaterialDotPlot = (sections, reference) => {
    if (!Array.isArray(sections)) return { sections: [], max: 0 }

    // 'Niet ingevuld' is geen kenmerk om mee te vergelijken, en een vraag met
    // één groep heeft niets om tegen af te zetten. In de tabellen eronder
    // staan ze wel.
    const vergelijkbaar = sections
        .map((sectie) => ({
            ...sectie,
            rows: sectie.rows.filter((r) => r.key !== 'niet-ingevuld' && typeof r.benchmarkLevel === 'number'),
        }))
        .filter((sectie) => sectie.rows.length >= 2)

    if (!vergelijkbaar.length) return { sections: [], max: 0 }

    // Vanaf 0, tot een rond getal boven alles: afstanden blijven eerlijk en de
    // benchmarklijn staat altijd in beeld.
    const waarden = vergelijkbaar.flatMap((s) => s.rows.map((r) => r.benchmarkLevel))
    if (typeof reference === 'number') waarden.push(reference)
    const max = Math.max(STAP, Math.ceil(Math.max(...waarden) / STAP) * STAP)

    return { sections: vergelijkbaar, max }
}

export default buildMaterialDotPlot
